import { Component, OnInit } from '@angular/core';
import {BehaviorSubject} from "rxjs";
import {ApiRestService} from "../api-rest.service";
import {QrMessage} from "../_Models/qr-message";
import {ApiPathsService} from "../../api-paths.service";
import {AuthenticationService} from  "../authentication.service";
//import pkg from '../GetMac'
import { v4 as uuidv4 } from 'uuid';
import {webSocket} from "rxjs/webSocket";
@Component({
  selector: 'app-qr-page',
  templateUrl: './qr-page.component.html',
  styleUrls: ['./qr-page.component.scss']
})
export class QrPageComponent  {
  availableDevices: MediaDeviceInfo[];
  deviceCurrent: MediaDeviceInfo;
  deviceSelected: string;

  hasDevices: boolean;
  hasPermission: boolean;
  qrResultString: string;
  torchEnabled = false;
  torchAvailable$ = new BehaviorSubject<boolean>(false);
  tryHarder = false;
  device_id = "";
  constructor(
    private ApiRestService: ApiRestService,
    private ApiPathService: ApiPathsService,
    private AuthenticationService: AuthenticationService,
  ) {
    // if(this.AuthenticationService.currentUserValue) {
    //   const subject = webSocket(`ws://${this.AuthenticationService.currentUserValue.synfra_url.replace("http://", "").replace("/web", "")}/broadcast`);
    //   subject.complete();
    // }
  }

  onCodeResult(resultString: string) {
    this.qrResultString = resultString;
    var send: QrMessage = JSON.parse(resultString);
    send.device_id = localStorage.getItem('device_id')  ?? uuidv4();
    localStorage.setItem('device_id', send.device_id);
    this.ApiPathService.setBaseAPI(send.synfra_url);
    this.AuthenticationService.login(send).subscribe(data=>{
      if(!data.status)
        this.clearResult()
    },error => this.clearResult());
  }



  clearResult(): void {
    this.qrResultString = null;
  }
  onCamerasFound(devices: MediaDeviceInfo[]): void {
    this.availableDevices = devices;
    this.hasDevices = Boolean(devices && devices.length);
  }

  onDeviceSelectChange(selected: string) {
    console.log(selected)
    const selectedStr = selected || '';
    if (this.deviceSelected === selectedStr) { return; }
    this.deviceSelected = selectedStr;
    const device = this.availableDevices.find(x => x.deviceId === selected);
    this.deviceCurrent = device || undefined;
  }

  onDeviceChange(device: MediaDeviceInfo) {
    const selectedStr = device?.deviceId || '';
    if (this.deviceSelected === selectedStr) { return; }
    this.deviceSelected = selectedStr;
    this.deviceCurrent = device || undefined;
  }

  onHasPermission(has: boolean) {
    this.hasPermission = has;
  }
  onTorchCompatible(isCompatible: boolean): void {
    this.torchAvailable$.next(isCompatible || false);
  }
  toggleTorch(): void {
    this.torchEnabled = !this.torchEnabled;
  }
  toggleTryHarder(): void {
    this.tryHarder = !this.tryHarder;
  }

}
